<section class="px-1">
  <div class="mat-account-wrapper p-0 ms-0">
    <div class="content-box non-tab add-school-tab p-4">
      <div class="row">
        <div class="col-sm-3">
          <span class="text-blacka fs-18 font-bold mb-3">School Details</span>
        </div>
        <div class="col-sm-9 text-end">
          <span *ngIf="!isEdit">
            <mat-icon matTooltip="Reset Form" class="cursor-pointer" (click)="clearSchoolForm()">refresh</mat-icon>
          </span>
          <button type="button" class="btn theme-btn px-3 ms-3" (click)="downloadFile()">
            <img class="me-2" src="../assets/images/document-upload.svg" alt=""/>Download Template
          </button>
          <input hidden multiple type="file" accept=".xlsx, .xls, .csv" #uploadFileInput (change)="loadExcelData($event)" />
          <button type="button" class="btn theme-btn px-3 ms-3" (click)="uploadFile()">
            <img class="me-2" src="../assets/images/document-upload.svg" alt=""/>Bulk Upload
          </button>
        </div>
      </div>
      <div class="bg-white row justify-content-between align-items-center radius8 mb-4">
        <div [formGroup]="schoolDetailsForm" class="col-sm-12">
          <div formArrayName="schools" class="tabs mb-0 tab-container">
            <ng-template #formFields let-school="school" let-i="index">
              <div [formGroupName]="i">
                <div class="row mt-3 justify-content-end">
                  <button *ngIf="schools.length > 1" type="button" class="btn link-delete link-delete-school border-red px-2 ms-3 fs-14 col-md-2" (click)="removeSchool(i)">
                    <img class="me-2" src="../assets/images/delete-icon.svg" alt=""/>
                    Delete School
                  </button>
                  <button type="button" class="btn theme-btn-blueoutline px-2 me-3 fs-14 col-md-3 w185" 
                    (click)="addSchool()">
                    <img class="me-2" src="../assets/images/add.svg" />
                    Add Another School
                  </button>
                </div>

                <div class="row my-2">
                  <div class="col-sm-6">
                    <div class="mb-0">
                      <span class="black-text fs-14 mb-1">School Code</span>
                      <input type="text" formControlName="id" class="form-control" [required]="true" [readOnly]="isEdit"
                        [class.is-invalid]="
                        school.get('id')!.invalid &&
                        school.get('id')!.touched" />
                    </div>
                    <div *ngIf="
                      (school.get('id')!.invalid &&
                       school.get('id')!.touched) ||
                       school.get('id')!.dirty">
                      <small *ngIf="school.get('id')!.errors?.['required']" class="text-danger fs-13">
                        School Code is required
                      </small>
                    </div>
                  </div>
                  <div *ngIf="isIndividualEntity" class="col-sm-6">
                    <div class="mb-4 mat-account-selectoption">
                      <div class="d-flex">
                        <mat-label class="black-text fs-14 mb-1">Assign Account Admin</mat-label>
                        <mat-icon matTooltip="Assign an Account Admin for the Independent School you are creating"
                          class="fs-22 ms-2">info</mat-icon>
                      </div>
                      <mat-form-field>
                        <mat-select [required]="true" formControlName="assignedAccountAdmin" [class.is-invalid]="
                            school.get('assignedAccountAdmin')!.invalid &&
                            school.get('assignedAccountAdmin')!.touched">
                          @for (accountAdmin of accountAdminList; track accountAdmin) {
                          <mat-option [value]="accountAdmin">{{
                            accountAdmin.firstName?.concat(" " + accountAdmin.lastName || "")
                            }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <div *ngIf="
                          (school.get('assignedAccountAdmin')!.invalid &&
                          school.get('assignedAccountAdmin')!.touched) ||
                          school.get('assignedAccountAdmin')!.dirty">
                        <small *ngIf="school.get('assignedAccountAdmin')!.errors?.['required']"
                          class="text-danger fs-13">Account Admin is required</small>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row my-2">
                  <div class="col-sm-6">
                    <div class="mb-0">
                      <span class="black-text fs-14 mb-1">School Name</span>
                      <input type="text" [required]="true" formControlName="schoolName" class="form-control" 
                      [readOnly]="isEdit"
                        [class.is-invalid]="
                        school.get('schoolName')!.invalid &&
                        school.get('schoolName')!.touched" />
                    </div>
                    <div *ngIf="
                      (school.get('schoolName')!.invalid &&
                       school.get('schoolName')!.touched) ||
                       school.get('schoolName')!.dirty">
                      <small *ngIf="school.get('schoolName')!.errors?.['required']" class="text-danger fs-13">
                        School Name is required
                      </small>
                      <small *ngIf="school.get('schoolName')!.errors?.['pattern']" class="text-danger fs-13">
                        Please provide a valid School Name
                      </small>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="mb-0">
                      <span class="black-text fs-14 mb-1">Location</span>
                      <input type="text" [required]="true" formControlName="location" class="form-control"
                        [class.is-invalid]="
                        school.get('location')!.invalid &&
                        school.get('location')!.touched" />
                    </div>
                    <div *ngIf="
                      (school.get('location')!.invalid &&
                       school.get('location')!.touched) ||
                       school.get('location')!.dirty">
                      <small *ngIf="school.get('location')!.errors?.['required']" class="text-danger fs-13">
                        Location is required
                      </small>
                      <small *ngIf="school.get('location')!.errors?.['pattern']" class="text-danger fs-13">
                        Please provide a valid Location
                      </small>
                    </div>
                  </div>
                </div>

                <div class="row my-3">
                  <div class="col-sm-6">
                    <div class="mb-0">
                      <div class="d-flex">
                      <p class="black-text fs-14 mb-1">Total number of users to be created</p>
                      <mat-icon class="ms-2 fs-22" matTooltip="Provide the number of school users(incl of SchoolAdmin) to be created under this school">info</mat-icon>
                    </div>
                      <div class="input-container">
                        <input type="number" min="1" [required]="true" formControlName="numberOfSchoolUser" class="form-control"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57" [class.is-invalid]="
                            school.get('numberOfSchoolUser')!.invalid &&
                            school.get('numberOfSchoolUser')!.touched" />
                       
                      </div>
                    </div>
                    <div *ngIf="
                        (school.get('numberOfSchoolUser')!.invalid &&
                         school.get('numberOfSchoolUser')!.touched) ||
                         school.get('numberOfSchoolUser')!.dirty">
                      <small *ngIf="school.get('numberOfSchoolUser')!.errors?.['required']"
                        class="text-danger fs-13">Total number of users to be created is required
                      </small>
                      <small *ngIf="school.get('numberOfSchoolUser')!.errors?.['pattern']" class="text-danger fs-13">
                        Please provide a valid School Users Count
                      </small>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="mb-0">
                      <div class="d-flex">
                      <span class="black-text fs-14 mb-1">School Capacity</span>
                      <mat-icon matTooltip="Enter the capacity of your school" class="ms-2 fs-22">info</mat-icon>
                    </div>
                      <div class="input-container">
                        <input type="number" min="1" [required]="true" formControlName="schoolCapacity" class="form-control"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57" [class.is-invalid]="
                            school.get('schoolCapacity')!.invalid &&
                            school.get('schoolCapacity')!.touched" />
                      
                      </div>
                    </div>
                    <div *ngIf="
                        (school.get('schoolCapacity')!.invalid &&
                         school.get('schoolCapacity')!.touched) ||
                         school.get('schoolCapacity')!.dirty">
                      <small *ngIf="school.get('schoolCapacity')!.errors?.['required']"
                        class="text-danger fs-13">School Capacity is required
                      </small>
                      <small *ngIf="school.get('schoolCapacity')!.errors?.['pattern']" class="text-danger fs-13">
                        Please provide a valid School Capacity
                      </small>
                    </div>
                  </div>
                </div>

                <div class="row my-3">
                  <div class="col-sm-6">
                    <div class="mb-0">
                      <div class="d-flex">
                      <span class="black-text fs-14 mb-1">Headcount of School</span>
                      <mat-icon matTooltip="Enter the total head count of school" class="ms-2 fs-22">info</mat-icon>
                    </div>
                      <div class="input-container">
                        <input type="number" min="1" [required]="true" formControlName="headcountOfSchool" class="form-control"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57" [class.is-invalid]="
                            school.get('headcountOfSchool')!.invalid &&
                            school.get('headcountOfSchool')!.touched" />
                        
                      </div>
                    </div>
                    <div *ngIf="
                        (school.get('headcountOfSchool')!.invalid &&
                         school.get('headcountOfSchool')!.touched) ||
                         school.get('headcountOfSchool')!.dirty">
                      <small *ngIf="school.get('headcountOfSchool')!.errors?.['required']"
                        class="text-danger fs-13">Headcount of School is required
                      </small>
                      <small *ngIf="school.get('headcountOfSchool')!.errors?.['pattern']" class="text-danger fs-13">
                        Please provide a valid Headcount of School
                      </small>
                    </div>  
                  </div>
                  <div class="col-sm-6">
                    <div class="mb-0">
                      <div class="d-flex">
                      <span class="black-text fs-14 mb-1">Number of Non-Teaching Staff</span>
                      </div>
                      <div class="input-container">
                        <input type="number" min="1" [required]="true" formControlName="numberOfNonTeachingStaff" class="form-control"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57" [class.is-invalid]="
                            school.get('numberOfNonTeachingStaff')!.invalid &&
                            school.get('numberOfNonTeachingStaff')!.touched" />
                     
                      </div>
                    </div>
                    <div *ngIf="
                        (school.get('numberOfNonTeachingStaff')!.invalid &&
                         school.get('numberOfNonTeachingStaff')!.touched) ||
                         school.get('numberOfNonTeachingStaff')!.dirty">
                      <small *ngIf="school.get('numberOfNonTeachingStaff')!.errors?.['required']"
                        class="text-danger fs-13">Number of Non-Teaching Staff is required
                      </small>
                      <small *ngIf="school.get('numberOfNonTeachingStaff')!.errors?.['pattern']" class="text-danger fs-13">
                        Please provide a valid Number of Non-Teaching Staff
                      </small>
                    </div>  
                  </div>
                </div>

                <div class="row my-3">
                  <div class="col-sm-6">
                    <div class="mb-0">
                      <div class="d-flex">
                      <span class="black-text fs-14 mb-1">Number of Teaching Staff</span>
                    </div>
                      <div class="input-container">
                        <input type="number" min="1" [required]="true" formControlName="numberOfTeachingStaff" class="form-control"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57" [class.is-invalid]="
                            school.get('numberOfTeachingStaff')!.invalid &&
                            school.get('numberOfTeachingStaff')!.touched" />
                       
                      </div>
                    </div>
                    <div *ngIf="
                        (school.get('numberOfTeachingStaff')!.invalid &&
                         school.get('numberOfTeachingStaff')!.touched) ||
                         school.get('numberOfTeachingStaff')!.dirty">
                      <small *ngIf="school.get('numberOfTeachingStaff')!.errors?.['required']"
                        class="text-danger fs-13">Number of Teaching Staff is required
                      </small>
                      <small *ngIf="school.get('numberOfTeachingStaff')!.errors?.['pattern']" class="text-danger fs-13">
                        Please provide a valid Number of Teaching Staff
                      </small>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="mb-0">
                      <div class="d-flex">
                      <span class="black-text fs-14 mb-1">Curriculum</span>
                      <mat-icon matTooltip="Enter the curriculum followed by the school" class="ms-2 fs-22">info</mat-icon>
                    </div>
                      <div class="input-container">
                        <input type="text" [required]="true" formControlName="curriculum" class="form-control"
                          [class.is-invalid]="
                          school.get('curriculum')!.invalid &&
                          school.get('curriculum')!.touched" />
                    
                      </div>
                    </div>
                    <div *ngIf="
                      (school.get('curriculum')!.invalid &&
                       school.get('curriculum')!.touched) ||
                       school.get('curriculum')!.dirty">
                      <small *ngIf="school.get('curriculum')!.errors?.['required']" class="text-danger fs-13">
                        Curriculum is required
                      </small>
                      <small *ngIf="school.get('curriculum')!.errors?.['pattern']" class="text-danger fs-13">
                        Please provide a valid Curriculum
                      </small>
                    </div>
                  </div>
                </div>

                <div class="row my-2">
                  <div class="col-sm-6">
                    <div class="mb-0">
                      <div class="d-flex">
                      <span class="black-text fs-14 mb-1">School Type</span>
                      <mat-icon matTooltip="Enter the school type" class="ms-2 fs-22">info</mat-icon>
                    </div>
                      <div class="input-container">
                        <input type="text" [required]="true" formControlName="schoolType" class="form-control"
                          [class.is-invalid]="
                          school.get('schoolType')!.invalid &&
                          school.get('schoolType')!.touched" />
                       
                      </div>
                    </div>
                    <div *ngIf="
                      (school.get('schoolType')!.invalid &&
                       school.get('schoolType')!.touched) ||
                       school.get('schoolType')!.dirty">
                      <small *ngIf="school.get('schoolType')!.errors?.['required']" class="text-danger fs-13">
                        School Type is required
                      </small>
                      <small *ngIf="school.get('schoolType')!.errors?.['pattern']" class="text-danger fs-13">
                        Please provide a valid School Type
                      </small>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="mb-0">
                      <span class="black-text fs-14 mb-1">Address</span>
                      <input type="text" [required]="true" formControlName="address" class="form-control"
                        [class.is-invalid]="
                        school.get('address')!.invalid &&
                        school.get('address')!.touched" />
                    </div>
                    <div *ngIf="
                      (school.get('address')!.invalid &&
                       school.get('address')!.touched) ||
                       school.get('address')!.dirty">
                      <small *ngIf="school.get('address')!.errors?.['required']" class="text-danger fs-13">
                        Address is required
                      </small>
                      <small *ngIf="school.get('address')!.errors?.['pattern']" class="text-danger fs-13">
                        Please provide a valid Address
                      </small>
                    </div>
                  </div>
                </div>

                <div class="row my-3">  
                  <div class="col-sm-6">
                    <div class="mb-0">
                      <div class="d-flex">
                      <span class="black-text fs-14 mb-1">Local Authority</span>
                      <mat-icon matTooltip="Enter the local authority with respect to your school" class="ms-2 fs-22">info</mat-icon>
                      </div>
                      <div class="input-container">
                        <input type="text" [required]="true" formControlName="localAuthority" class="form-control"
                          [class.is-invalid]="
                          school.get('localAuthority')!.invalid &&
                          school.get('localAuthority')!.touched" />
                        
                      </div>
                    </div>
                    <div *ngIf="
                      (school.get('localAuthority')!.invalid &&
                       school.get('localAuthority')!.touched) ||
                       school.get('localAuthority')!.dirty">
                      <small *ngIf="school.get('localAuthority')!.errors?.['required']" class="text-danger fs-13">
                        Local Authority is required
                      </small>
                      <small *ngIf="school.get('localAuthority')!.errors?.['pattern']" class="text-danger fs-13">
                        Please provide a valid Local Authority
                      </small>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="mb-0">
                      <span class="black-text fs-14 mb-1">ID: URN/DfE Number/UKPRN</span>
                      <input type="text" [required]="true" formControlName="schoolRegistrationId" class="form-control"
                         [class.is-invalid]="
                          school.get('schoolRegistrationId')!.invalid &&
                          school.get('schoolRegistrationId')!.touched" />
                    </div>
                    <div *ngIf="
                        (school.get('schoolRegistrationId')!.invalid &&
                         school.get('schoolRegistrationId')!.touched) ||
                         school.get('schoolRegistrationId')!.dirty">
                      <small *ngIf="school.get('schoolRegistrationId')!.errors?.['required']"
                        class="text-danger fs-13">ID: URN/DfE Number/UKPRN is required
                      </small>
                    </div>
                  </div>
                </div>

                <div class="row my-3">
                  <div class="col-sm-6">
                    <div class="mb-0">
                      <div class="d-flex">
                      <span class="black-text fs-14 mb-1">Notes</span>
                    </div>
                      <div class="input-container">
                        <textarea class="form-control" formControlName="notes" rows="3" [class.is-invalid]="
                            school.get('notes')!.invalid &&
                            school.get('notes')!.touched
                          ">
                        </textarea>
                      
                      </div>
                    </div>
                    <div *ngIf="
                      (school.get('notes')!.invalid &&
                       school.get('notes')!.touched) ||
                       school.get('notes')!.dirty
                    ">
                      <small *ngIf="school.get('notes')!.errors?.['required']" class="text-danger fs-13">
                        Notes is required
                      </small>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="mb-0">
                      <div class="d-flex">
                        <span class="black-text fs-14 mb-1">Upload</span>
                        <mat-icon matTooltip="Attach documents related to school" class="ms-2 fs-22">info</mat-icon>
                      </div>
                      <div class="mt-0 px-3 py-3 custom-file-input">
                        <div class="file-input-wrapper">
                          <span class="file-name"> {{ selectedSchoolFileCount[i] > 0 ? selectedSchoolFileCount[i] + ' file(s) selected' : 'Click to upload' }}</span>
                          <input
                            hidden
                            multiple
                            type="file"
                            #schoolFileInput
                            (change)="onFileSelected($event, i)"
                          />
                          <button
                            class="btn theme-btn px-2 ms-3 border-sm-0"
                            mat-raised-button
                            color="primary"
                            (click)="uploadFromLocal($event, i)"
                          >
                            Upload
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="divider mb-4 mt-2"></div>
                <div formGroupName="schoolAdmin" >
                  <h3 class="d-flex justify-content-between py-2">
                    School Admin Details
                  </h3>
                  <ng-container>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="mb-4 mat-account-selectoption">
                          <mat-label class="black-text fs-14 mb-1">Title</mat-label>
                          <mat-form-field>
                            <mat-select formControlName="title" [class.is-invalid]="
                                school.get('schoolAdmin.title')!.invalid &&
                                school.get('schoolAdmin.title')!.touched">
                              @for (title of ['Ms', 'Mrs', 'Mr']; track title) 
                              {
                                <mat-option [value]="title">{{ title }}</mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                          <div *ngIf="
                          (school.get('schoolAdmin.title')!.invalid &&
                          school.get('schoolAdmin.title')!.touched) ||
                          school.get('schoolAdmin.title')!.dirty">
                        <!-- <small *ngIf="school.get('schoolAdmin.title')!.errors?.['required']"
                          class="text-danger fs-13">Title is required</small> -->
                            <small *ngIf="school.get('schoolAdmin.title')!.errors?.['pattern']"
                              class="text-danger fs-13">Please provide a valid Title
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="mb-4">
                          <span class="black-text fs-14 mb-1">First Name</span>
                          <input type="text" formControlName="firstName" class="form-control"
                            [readOnly]="isEdit"
                            [class.is-invalid]="
                              school.get('schoolAdmin.firstName')!.invalid &&
                              school.get('schoolAdmin.firstName')!.touched" />
                          <div *ngIf="
                              (school.get('schoolAdmin.firstName')!.invalid &&
                               school.get('schoolAdmin.firstName')!.touched) ||
                               school.get('schoolAdmin.firstName')!.dirty">
                            <!-- <small *ngIf="school.get('schoolAdmin.firstName')!.errors?.['required']"
                              class="text-danger fs-13">First Name is required</small> -->
                            <small *ngIf="school.get('schoolAdmin.firstName')!.errors?.['pattern']"
                              class="text-danger fs-13">Please provide a valid First Name</small>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <div class="mb-4">
                          <span class="black-text fs-14 mb-1">Last Name</span>
                          <input type="text" formControlName="lastName" class="form-control" 
                            [readOnly]="isEdit"
                            [class.is-invalid]="
                              school.get('schoolAdmin.lastName')!.invalid &&
                              school.get('schoolAdmin.lastName')!.touched" />
                          <div *ngIf="
                              (school.get('schoolAdmin.lastName')!.invalid &&
                               school.get('schoolAdmin.lastName')!.touched) ||
                               school.get('schoolAdmin.lastName')!.dirty">
                            <!-- <small *ngIf="school.get('schoolAdmin.lastName')!.errors?.['required']"
                              class="text-danger fs-13">Last Name is required</small> -->
                            <small *ngIf="school.get('schoolAdmin.lastName')!.errors?.['pattern']"
                              class="text-danger fs-13">Please provide a valid Last Name</small>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="mb-4">
                          <span class="black-text fs-14 mb-1">Email Address</span>
                          <input type="text" formControlName="emailId" class="form-control"
                            [readOnly]="isEdit"
                            [class.is-invalid]="
                              school.get('schoolAdmin.emailId')!.invalid &&
                              school.get('schoolAdmin.emailId')!.touched" />
                          <div *ngIf="
                              (school.get('schoolAdmin.emailId')!.invalid &&
                               school.get('schoolAdmin.emailId')!.touched) ||
                               school.get('schoolAdmin.emailId')!.dirty">
                            <!-- <small *ngIf="school.get('schoolAdmin.emailId')!.errors?.['required']"
                              class="text-danger fs-13">Email Address is required</small> -->
                            <small *ngIf="school.get('schoolAdmin.emailId')!.errors?.['pattern']"
                              class="text-danger fs-13 mt-2">Please provide a valid Email Address</small>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 mb-0 contact-number">
                        <span class="black-text fs-14 mb-1">Contact Number</span>
                        <mat-form-field class="contact-mat-form" appearance="outline" [class.is-invalid]="
                            school.get('schoolAdmin.contactNumber')!.invalid &&
                            school.get('schoolAdmin.contactNumber')!.touched">
                          <ngx-mat-intl-tel-input [enablePlaceholder]="true"[enableSearch]="true"
                            formControlName="contactNumber" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            [preferredCountries]="['gb']">
                          </ngx-mat-intl-tel-input>
                        </mat-form-field>
                        <div *ngIf="
                            (school.get('schoolAdmin.contactNumber')!.invalid &&
                             school.get('schoolAdmin.contactNumber')!.touched) ||
                             school.get('schoolAdmin.contactNumber')!.dirty">
                          <small *ngIf="
                              school.get('schoolAdmin.contactNumber')!.invalid" class="text-danger fs-13">Please provide a valid Contact Number</small>
                        </div>
                      </div>
                    
                      <div class="col-sm-6">
                        <div class="mb-4">
                          <div class="d-flex">
                            <span class="black-text fs-14 mb-1">Upload</span>
                            <mat-icon matTooltip="Attach documents related to school admin" class="ms-2 fs-22">info</mat-icon>
                          </div>
                          <div class="mt-0 px-3 py-3 custom-file-input">
                            <div class="file-input-wrapper">
                              <span class="file-name">{{ selectedSchoolAdminFileCount[i] > 0 ? selectedSchoolAdminFileCount[i] + ' file(s) selected' : 'Click to upload' }}</span>
                              <input
                                hidden
                                multiple
                                type="file"
                                #schoolAdminFileInput
                                (change)="onSchoolAdminFileSelected($event, i)"
                              />
                              <button
                                class="btn theme-btn px-2 ms-3 border-sm-0"
                                mat-raised-button
                                color="primary"
                                (click)="SchoolAdminuploadFromLocal($event, i)"
                              >
                                Upload
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-template>

            <ng-container *ngIf="schools.length > 1; else singleSchoolForm">
              <mat-tab-group #tabGroup>
                <mat-tab [label]="school.get('schoolName')!.value ? school.get('schoolName')!.value : '#New School'" *ngFor="let school of schools.controls; let i = index">
                  <ng-container *ngTemplateOutlet="formFields; context: {school: school, index: i}"></ng-container>
                </mat-tab>
              </mat-tab-group>
            </ng-container>

            <ng-template #singleSchoolForm>
              <div *ngIf="schools.length === 1">
                <ng-container *ngTemplateOutlet="formFields; context: {school: schools.at(0), index: 0}"></ng-container>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
